import Headroom from "headroom.js";

let library = {
    'observer': function() {
        var opacityTargets = document.querySelectorAll('.is-opacity');
        let movingTargets = document.querySelectorAll('.is-move');
        let movingTargetsLtr = document.querySelectorAll('.is-move-ltr');
        let willBeFancy = document.querySelectorAll('.will-be-fancy');
        let willBeFancy2 = document.querySelectorAll('.will-be-fancy-2');
        let willBeTyped = document.querySelectorAll('.typed');

        let newTargets = [...opacityTargets, ...movingTargets, ...movingTargetsLtr];
        let animatedTargets = [...willBeFancy, ...willBeFancy2];
        let typingTargets = [...willBeTyped];

        const options = {
            root: null,
            rootMargin: '0px 20px 0px 30px',
            threshold: [0, 0.25, 0.75, 1]
        }
        
        observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if(entry.intersectionRatio > 0.5) {
                    entry.target.classList.add('fancy');
                    observer.unobserve(entry.target)
                }
            }) 
        }, options);

        observer2 = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                // const boundsRect = entry.boundingClientRect;
                if(entry.intersectionRatio > 0.5) {
                    // console.log(boundsRect.y)
                    entry.target.classList.add('fancy-dual-box');
                    observer.unobserve(entry.target)
                }
            })
        }, options);


        newTargets.forEach(myTarget => {
            observer.observe(myTarget)
        })
        animatedTargets.forEach(target => {
            observer2.observe(target)
        })

    },
    'swiper': function(bodyClass) {
        if(document.body.classList.contains(bodyClass)) {
            let slideIndex = 0;
            let slides = document.getElementsByClassName("slider");
            if(slides !== null) {
                showSlides();
            }
            function showSlides() {
              let i;
              let slides = document.getElementsByClassName("slider");
              if(slides !== null) {
                    let pages = document.querySelectorAll(".slider-controls li");
                    let overlay = document.getElementById("overlay")
                    for (i = 0; i < slides.length; i++) {
                        slides[i].classList.contains("slide-active") ? slides[slideIndex-1].classList.toggle("slide-active") : '';
                        pages[i].classList.contains("active") ? pages[slideIndex-1].classList.toggle("active") : '';
                    }
                    slideIndex++;
                    if (slideIndex > slides.length) {slideIndex = 1}
                    if(slides){
                        console.log(slides)
                        slides[slideIndex-1].classList.toggle("slide-active");
                        pages[slideIndex-1].classList.toggle("active");
                        setTimeout(showSlides, (slides.length*2000)); // Change image every 2 seconds
                    }
                }
            }
        }
    },
    'overlays': function() {
        let overlay1 = document.getElementById("overlay1")
        let overlay2 = document.getElementById("overlay2")
        let overlay3 = document.getElementById("overlay3")
        if(document.body.classList.contains('home')) {
            overlay1.style.width = '200%';
            overlay2.style.width = '200%';
            overlay3.style.width = '200%';
        }
    },
    'letters': function() {
        let letters = document.querySelectorAll('.hero--text-wrap span')
        let i
        let timer = 800
        
        letters.forEach(letter => {
            setTimeout(() => {
                letter.style.opacity = '1';
                letter.style.transform = 'scale(1)';
            },timer)
            timer+= 100
        });
    },
    'headroom': function() {
        let myElement = document.querySelector("header");
        let headroom  = new Headroom(myElement);
        headroom.init()
    },
    'toTop': () => {
        const btn = document.getElementById("btnToTop");
        window.onscroll = function() {scrollFunction()};
        function scrollFunction() {
            if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
                if(btn !== null) {
                    btn.classList.remove("inactive");
                }
            } else {
                if(btn !== null) {
                    btn.classList.add("inactive");
                }
            }
        }
        function topFunction() {
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            }
            if(btn !== null) {
                btn.addEventListener("click", () => {
                        topFunction()
                })
            }
    },
    'navigation': function() {
        /***
         * HAMBURGER MENU
        */
        const hamburger = document.querySelector('.hamburger')
        const close = document.querySelector('.close-btn')
        if(hamburger !== null) {
            hamburger.addEventListener('click', (e) => {
                document.body.classList.toggle('nav-is-active')
            })
        }
        if(close !== null) {
            close.addEventListener('click', (e) => {
                document.body.classList.toggle('nav-is-active')
            })
        }


        /***
         * HAMBURGER MENU NAV PANEL
         */
        const subMenu = document.querySelector(".menu-sub");
        if(subMenu !== null) {
            subMenu.addEventListener("click", function() {
                document.body.classList.toggle('menu-is-open')
                const panel = document.querySelector(".submenu");
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        }

    },
    'accordion': function() {
        let firsts = document.querySelectorAll('.menu-title')
        let i;
        
        for (i = 0; i < firsts.length; i++) {
          firsts[i].addEventListener("click", function() {
            this.classList.toggle("active");
            let panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
              panel.style.maxHeight = null;
            } else {
              panel.style.maxHeight = panel.scrollHeight + "px";
            }
          });
        }
    },
    'bottomFixedNav': function() {
        const btnToTop = document.getElementById('btnToTop')
        const footer = document.getElementById('footer')
        const nav = document.querySelector('nav')
        window.addEventListener('scroll', () => {
            if(document.body.scrollHeight - window.scrollY <= window.innerHeight + footer.offsetHeight) {
                if(window.innerWidth <= 768) {
                    nav.style.bottom = footer.offsetHeight + 'px'
                    btnToTop.style.bottom = (btnToTop.offsetHeight + footer.offsetHeight + 20) + 'px'
                }
                else {
                    btnToTop.style.bottom = btnToTop.offsetHeight + 'px'
                }
            }
            else {
                if(window.innerWidth <= 768) {
                    nav.style.bottom = 0
                    btnToTop.style.bottom = (nav.offsetHeight + 10) + 'px'
                }
                else {
                    btnToTop.style.bottom = '20px'
                }
            }
        })
    },
    'contactCard': function() {
        const header = document.querySelector('.header')
        const nav = document.querySelector('nav')
        const card = document.querySelector('.header .contact')
        card.style.top = ((header.offsetHeight - card.offsetHeight) + nav.offsetHeight) + 'px'
        if(window.innerWidth < 1500) {
            card.style.top = 'auto'
            card.style.bottom = 0
        }
        if(window.innerWidth < 1100) {
            card.classList.add('card-is-out')
            card.style.top = '50%'
            card.style.bottom = 'auto'
        }
        window.addEventListener('scroll', () => {
            if(window.scrollY >= 10) {
                card.classList.add('card-is-out')
            }
            if(window.scrollY < 10) {
                // card.classList.remove('card-is-out')
                card.classList.remove('card-active')
            }
        })
        card.addEventListener('click', () => {
            card.classList.toggle('card-active')
        })
    

    },
    'newsAccordion': function() {
        const news = document.querySelector('.news')
        const newsContent = document.querySelector('.news-content p')
        const newsBtn = document.querySelectorAll('.details a')
        newsContent.style.maxHeight = 0;
        newsBtn.forEach(el => el.addEventListener('click', () => {
            news.classList.toggle('news-is-close')
            if(news.classList.contains('news-is-close')) {
                newsContent.style.maxHeight = 0;
            }
            else {
                newsContent.style.maxHeight = newsContent.scrollHeight + "px";
            }
        }))
    },
    'contactDownload': function() {
        const downloadBtn = document.querySelector(`[name=download]`)

        if(downloadBtn !== null) {
            console.log(downloadBtn)
            downloadBtn.addEventListener('click', (e) => {
                // e.preventDefault()
            })
        }
    },
    'homepage': function() {
        // console.log('test homepage')
        this.observer()
        // this.overlays()
        // this.letters()
        this.headroom()
        this.toTop()
        // this.newsAccordion()
        // this.bottomFixedNav()
        if(window.innerWidth > 768) {
            // this.contactCard()
        }
        this.navigation()
        this.accordion()
        this.contactDownload()
        // this.swiper('home')
        // this.accordionNavSp()
    },
    // 'page': function() {
    //     console.log('test page')
    //     this.navigation()
    //     this.headroom()
    //     this.toTop()
    //     this.observer()
    //     this.accordion()
    // },
    'init': function() {
        this.homepage();
        // this.page();
    }
}



// if (document.body.classList.contains('home')) {
    library.init()
    console.log('First init')
// }